"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AccessTokenModel", {
    enumerable: true,
    get: function() {
        return AccessTokenModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const AccessTokenModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    accessible_urls: _zod.z.array(_zod.z.string()),
    expires: _zod.z.date(),
    permanent: _zod.z.boolean(),
    token: _zod.z.string(),
    user: _zod.z.instanceof(_bson.ObjectId)
});
